var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb-header"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.bread),function(b,i){return _c('el-breadcrumb-item',{key:i},[(b.path)?_c('a',{on:{"click":_vm.goback}},[_vm._v(_vm._s(b.title))]):_c('span',[_vm._v(_vm._s(b.title))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }